<template>
  <v-row dense>
    <v-col cols="12" sm="12" md="4" lg="5">
      <v-text-field
        v-model="search"
        prepend-icon="mdi-magnify"
        label="Search anything here ..."
        single-line
        solo
        hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="6" sm="5" md="3" lg="3">
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="selectedDates"
        width="290px"
        class=""
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="selectedDatesText"
            prepend-icon="mdi-calendar"
            append-icon="mdi-chevron-down"
            readonly
            v-bind="attrs"
            v-on="on"
            solo
            class="custom-select"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="selectedDates"
          class="custom-date-picker"
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            class="error-text-lighten-1"
            text
            @click.prevent="cancelSelection"
          >
            Cancel
          </v-btn>
          <v-btn text @click.prevent="confirmSelection"> OK </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col cols="6" sm="5" md="3" lg="3">
      <v-select
        solo
        :items="formatedPaymentMethods"
        item-value="id"
        item-text="method_name"
        append-icon="mdi-chevron-down"
        label="All Transaction Method"
        class="custom-select"
        @change="selectPaymentMethod"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="2" md="2" lg="1">
      <ul>
        <li>
          <span>Total Withdrawal:</span>
          <span>{{ Number(totalWithdrawal)?.toFixed(2) }}</span>
        </li>
      </ul>
    </v-col>
    <v-col cols="12" sm="12">
      <v-card
        class="pa-0 rounded-0 elevation-0"
        :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
      >
        <v-sheet
          class="transactionTable ib-commission-table"
          :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-1'"
        >
          <v-data-table
            :items-per-page="10"
            :headers="headers"
            :search="search"
            :items="withdrawalStatistics"
            loading-text="Loading... Please wait"
            :loading="isLoading"
          >
            <template v-slot:item.reference="{ item }">
              {{ item?.reference || "N/A" }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ formatMySQLDate(item?.created_at) }}
            </template>
            <template v-slot:item.amount="{ item }">
              {{ "$ " + item?.amount }}
            </template>
            <template v-slot:item.status="{ item }">
              <span small :style="getColor(item?.status)">
                {{
                  item?.status === 0
                    ? "Pending"
                    : item?.status === 1
                    ? "Approved"
                    : item?.status === 2
                    ? "Canceled"
                    : "N/A"
                }}
              </span>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
    PARTNERCOMMISSION__ACTIONS,
    PAYMENTMETHODS__ACTIONS,
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Date & Time", value: "created_at" },
        { text: "Trx Type", value: "trx_type" },
        { text: "Trx Method", value: "method_name" },
        { text: "Reference No", value: "reference" },
        { text: "Amount ($)", value: "amount" },
        { text: "Trx Status", value: "status" },
      ],
      search: "",
      selectedDates: [],
      selectedDatesText: null,
      startDateValue: null,
      endDateValue: null,
      selectedMethod: null,
      modal: false,
    };
  },
  computed: {
    ...mapState("commissionstatistics", [
      "withdrawalStatistics",
      "totalWithdrawal",
      "isLoading",
    ]),
    ...mapState("paymentmethods", ["paymentMethods"]),

    formatedPaymentMethods() {
      const paymentMethods = this.paymentMethods.map((item) => {
        const { id, method_name } = item;
        return { id, method_name };
      });
      return ["All", ...paymentMethods];
    },
  },

  methods: {
    
   formatMySQLDate(date) {
  if (!date) return '';
  
  // Try to parse the date, whether it's ISO or already a Date object
  const parsedDate = date instanceof Date ? date : new Date(date);
  
  // Check if the date is valid
  if (isNaN(parsedDate.getTime())) return '';

  const day = parsedDate.getDate().toString().padStart(2, '0');
  const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
  const year = parsedDate.getFullYear();

  let hours = parsedDate.getHours();
  const minutes = parsedDate.getMinutes().toString().padStart(2, '0');

  const amPm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;

  return `${day}.${month}.${year} - ${hours}:${minutes} ${amPm}`;
},
    getColor(status) {
      if (status === 1)
        return "color: #039de9; background-color: rgba(2, 181, 138, 0.15); padding: 8px 13px; border-radius: 2px;";
      else if (status === 0) return "color: #D19909; background-color: rgba(2, 181, 138, 0.15); padding: 8px 13px; border-radius: 2px;";
      else return "color: red; background-color: rgba(2, 181, 138, 0.15); padding: 8px 13px; border-radius: 2px;";
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    ...mapActions("commissionstatistics", [
      PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONWITHDRAWAL,
    ]),

    ...mapActions("paymentmethods", [PAYMENTMETHODS__ACTIONS.PAYMENTMETHODS]),

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.startDateValue = startDate;
      this.endDateValue = endDate;

      const parameter = {
        payment_method:
          this.selectedMethod === null ||
          this.selectedMethod === undefined ||
          this.selectedMethod === "All"
            ? null
            : Number(this.selectedMethod),
        duration:
          startDate.toISOString().split("T")[0] +
          "to" +
          endDate.toISOString().split("T")[0],
      };

      this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONWITHDRAWAL](parameter);
      this.modal = false;
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    selectPaymentMethod(selectedMethod) {
      this.selectedMethod = selectedMethod;
      const parameter = {
        payment_method:
          this.selectedMethod === "All" ? null : Number(this.selectedMethod),
        duration:
          this.startDateValue && this.endDateValue
            ? `${this.startDateValue.toISOString().split("T")[0]}to${
                this.endDateValue.toISOString().split("T")[0]
              }`
            : null,
      };
      this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONWITHDRAWAL](parameter);
    },
  },
  async mounted() {
    await this[PARTNERCOMMISSION__ACTIONS.PARTNERCOMMISSIONWITHDRAWAL]();
    await this[PAYMENTMETHODS__ACTIONS.PAYMENTMETHODS]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
